import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'

// IMPORTAZIONI CSS E LIBRERIE
import './plugins/igotystyle.css'
import 'materialize-css/dist/css/materialize.min.css'
import 'materialize-css/dist/js/materialize.min.js'

// PLUGINS LOCALI
import validator from './plugins/validator'
import { startCookieUpdater, stopCookieUpdater } from './plugins/cookie-updater'
// CORREZIONE: Rimosso canLoadMarketing per risolvere l'errore 'no-unused-vars'
import { getCookiePreferences } from '@/plugins/cookie-checker'
import JsonExcel from 'vue-json-excel'

import RedTooltip from '@/plugins/redTooltip'
import { formatEventDate } from '@/plugins/dateFormatter.js'
Vue.prototype.$formatEventDate = formatEventDate

Vue.directive('red-tooltip', RedTooltip)

Vue.use(validator)
Vue.config.productionTip = false
Vue.use(VueMeta)
Vue.component('download-excel', JsonExcel)

// =========================================================================
// LOGICA DEI COOKIE E INIZIALIZZAZIONE CONDIZIONALE DI ANALYTICS (GDPR)
// =========================================================================

// Funzione per iniettare e configurare lo script Universal Analytics (analytics.js)
function initializeUniversalAnalytics () {
  // Evita di inizializzare più volte
  if (window.gaInitialized) return

  // Il tuo blocco di script avvolto in una funzione JS:
  const analyticsCode = 'window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'G-YV1H0YZR7Z\');'

  // 1. Crea l'elemento script
  const script = document.createElement('script')
  // Usa .textContent per inserire il blocco di codice come testo dello script
  script.textContent = analyticsCode

  // 2. Iniettalo nel DOM
  document.head.appendChild(script)

  window.gaInitialized = true
}

// Funzione principale che controlla e carica gli script
function checkAndLoadScripts (preferences) {
  if (preferences.analytics) {
    initializeUniversalAnalytics()
  }
  // L'implementazione del marketing qui è stata lasciata vuota,
  // quindi l'importazione della relativa funzione era inutile.
}

// **FASE 1: Controllo all'avvio dell'applicazione**
const initialPrefs = getCookiePreferences()
checkAndLoadScripts(initialPrefs)

// =========================================================================
// INIZIALIZZAZIONE DELL'ISTANZA VUE
// =========================================================================
new Vue({
  router,
  store,
  render: h => h(App),
  mounted () {
    startCookieUpdater() // Avvia il servizio di aggiornamento cookie

    // **FASE 2: Listener per aggiornamenti in tempo reale**
    this.$root.$on('cookies-updated', (newPreferences) => {
      checkAndLoadScripts(newPreferences)

      // Se l'utente ha appena accettato, traccia la pagina corrente subito
      if (newPreferences.analytics && window.ga && router.currentRoute) {
        window.ga('set', 'page', router.currentRoute.fullPath)
        window.ga('send', 'pageview')
      }
    })
  },
  beforeDestroy () {
    stopCookieUpdater() // Pulisci il servizio all'uscita dall'applicazione
  }
}).$mount('#app')
